module.exports = __webpack_public_path__ + "img/img09.4955bdf6.png";